<script setup lang="ts">
// Bottom tab bar of the phone shell: 64px plus the safe area, five tabs, 22px stroke icons, 11px labels.
import { useRoute, useRouter } from 'vue-router'
import AppIcon from '../components/AppIcon.vue'
import { TAB_NAV, isActive } from './nav'

const route = useRoute()
const router = useRouter()
</script>

<template>
  <nav id="clientTabbar" class="client-tabbar" aria-label="主导航">
    <button v-for="tab in TAB_NAV" :key="tab.id" type="button" :data-client-tab="tab.id" :class="{ 'is-active': isActive(tab, route.path) }"
      :aria-current="isActive(tab, route.path) ? 'page' : undefined" @click="router.push(tab.to)">
      <AppIcon :name="tab.icon" variant="client" /><span>{{ tab.label }}</span>
    </button>
  </nav>
</template>
